import { request } from "@shared/utils";
import { API, METHODS } from "@shared/constants";
import { SensorDataRestoringRequestFilter } from "@shared/interfaces";

import { CreateSensorDataRestoringRequestRequest } from "../interfaces";

export default {
  getSensorDataRestoringRequests: (payload: SensorDataRestoringRequestFilter) => {
    return request(
      METHODS.GET,
      API.SENSOR_DATA_RESTORING_REQUEST.GET_SENSOR_DATA_RESTORING_REQUESTS,
    )({ params: payload });
  },
  getSensorDataRestoringRequest: (requesId: number) => {
    return request(
      METHODS.GET,
      API.SENSOR_DATA_RESTORING_REQUEST.GET_SENSOR_DATA_RESTORING_REQUEST(String(requesId)),
    )();
  },
  downloadSensorDataRestoringRequest: (requesId: number) => {
    return request(
      METHODS.GET,
      API.SENSOR_DATA_RESTORING_REQUEST.DOWNLOAD_SENSOR_DATA_RESTORING_REQUEST(String(requesId)),
    )();
  },
  restoreSensorDataRestoringRequest: (requesId: number) => {
    return request(
      METHODS.GET,
      API.SENSOR_DATA_RESTORING_REQUEST.RESTORE_SENSOR_DATA_RESTORING_REQUEST(String(requesId)),
    )();
  },
  deleteSensorDataRestoringRequest: (requesId: number) => {
    return request(
      METHODS.GET,
      API.SENSOR_DATA_RESTORING_REQUEST.DELETE_SENSOR_DATA_RESTORING_REQUEST(String(requesId)),
    )();
  },
  createSensorDataRestoringRequest: (payload: CreateSensorDataRestoringRequestRequest) =>
    request(METHODS.POST, API.SENSOR_DATA_RESTORING_REQUEST.CREATE_SENSOR_DATA_RESTORING_REQUESTS)(payload),
};
